import { useState, useEffect } from "react";
import { siteConfig } from "@/config/site";
import whatsappAsset from "@/assets/whatsapp-icon.png.asset.json";

export interface FloatingWhatsAppProps {
  phoneNumber?: string;
  displayName?: string;
  initialMessage?: string;
}

export function FloatingWhatsApp({ 
  phoneNumber = siteConfig.contact.whatsapp.number, 
  displayName = siteConfig.contact.whatsapp.display, 
  initialMessage = siteConfig.contact.whatsapp.message 
}: FloatingWhatsAppProps) {
  const [isVisible, setIsVisible] = useState(false);

  const whatsappMsg = encodeURIComponent(initialMessage);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <a
        href={`https://wa.me/${phoneNumber}?text=${whatsappMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Chat with ${siteConfig.name} on WhatsApp at ${displayName}`}
        className={`group relative flex h-14 w-14 items-center justify-center rounded-full transition-all hover:scale-110 hover:shadow-[0_0_20px_rgba(37,211,102,0.4)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2`}
      >
        <span className="absolute -top-12 right-0 scale-0 rounded-lg bg-background border border-border px-3 py-1.5 text-xs font-medium text-foreground shadow-sm transition-all group-hover:scale-100 whitespace-nowrap">
          Chat with us!
        </span>
        <img 
          src={whatsappAsset.url} 
          alt="WhatsApp"
          className="w-full h-full object-contain"
        />
      </a>
    </div>
  );
}
